import mock from '../mock'

// ** Third Party Components
import axios from 'axios'

// ** Utils
import { paginateArray } from '../utils'

// ** Utils
import { getUserData } from '@utils'

// ** Custom Components
import GetApiCOC from '../../@fake-db/ApiCOC'

const base64ToString = (response) => { 

  if (response.data.Result === "true" && response.data.response_data.length > 0) {
    return JSON.parse(Buffer.from(response.data.response_data, "base64").toString()) 
  } else {
    return []
  }
}

const getComission = async (dataOrigen, refrescar, api, token, body, config) => {

  const configws = {
    method: 'get',
    url:    api,
    headers: { 
      Accept:      'application/json',
      obrientoken: token
    },
    params: body
  }

  let data = dataOrigen

  if (data.commission_data.length <= 0 || data.date_from !== config.startDate || data.date_to !== config.endDate) {
    const response = await axios(configws)
    data = {  commission_data: base64ToString(response) }
  }

  // eslint-disable-next-line object-curly-newline
  const { q = '', perPage = 10, page = 1, status = null, sort, sortColumn } = config
  /* eslint-enable */
  const dataAsc = data.commission_data.sort((a, b) => {
    if (a[sortColumn]) {
      return a[sortColumn] < b[sortColumn] ? -1 : 1
    } else {
      const splitColumn = sortColumn.split('.')
      const columnA = a[splitColumn[0]][splitColumn[1]]
      const columnB = b[splitColumn[0]][splitColumn[1]]
      return columnA < columnB ? -1 : 1
    }
  })

  const dataToFilter = sort === 'asc' ? dataAsc : dataAsc.reverse()

  const queryLowered = q.toLowerCase()
  const filteredData = dataToFilter.filter(comision_data => {

      return (
        (
          String(comision_data.comision_id).toLowerCase().includes(queryLowered) ||
          comision_data.date.toLowerCase().includes(queryLowered) ||
          comision_data.bank.toLowerCase().includes(queryLowered) ||
          String(comision_data.id_closure).toLowerCase().includes(queryLowered) ||
          comision_data.amount.toLowerCase().includes(queryLowered) ||
          comision_data.exchange_rate.toLowerCase().includes(queryLowered) ||
          comision_data.payment_method.toLowerCase().includes(queryLowered) ||
          comision_data.internal_closure_id.toLowerCase().includes(queryLowered) ||
          comision_data.currency.toLowerCase().includes(queryLowered) ||
          comision_data.office_name.toLowerCase().includes(queryLowered)

        ) 
        && 
        comision_data.comision_status === (status.length > 0 ? Number(status) : comision_data.comision_status)
      )
  })

  return [
    200,
    {
      allData: data.commission_data,
      total: filteredData.length,
      commission_data: filteredData.length <= perPage ? filteredData : paginateArray(filteredData, perPage, page)
    }
  ]  
}

// ------------------------------------------------
// GET: Return closure List for Comission
// ------------------------------------------------
let dataComissionMasterVer = JSON.parse(localStorage.getItem("dataComissionMasterVer")) || { commission_data: [], date_from: '', date_to: '', cluster: -1, country: -1, office: -1, user: -1}

mock.onGet('/apps/comissionMasterVer/list').reply(async config => {

  const user = getUserData()
  
  let cluster_id = ''
  let office_id  = ''
  let country_id = ''
  let user_id    = ''

  if (config.manager) {
    if (config.cluster_id !== -1 && config.cluster_id !== '') {
      cluster_id = config.cluster_id
    }

    if (config.country_id !== -1 && config.country_id !== '') {
      country_id = config.country_id
    }

    if (config.office_id !== -1 && config.office_id !== '') {
      office_id = config.office_id
    }
      
    if (config.user_id !== -1 && config.user_id !== '') {
      user_id  = config.user_id
    }
  } else {
    cluster_id = user.usercoc.cluster
    office_id  = user.usercoc.office_id
    country_id = user.usercoc.country
    user_id    = user.usercoc.username
  }
  
  const body = {
    internal_closure_id:    "",
    cluster:                cluster_id,
    country:                country_id,
    office:                 office_id,
    user:                   user_id,
    date_from:              config.startDate,
    date_to:                config.endDate,
    comision_status:        1,
    comision_status2:       3,
    comision_status3:       0
  }

  if (localStorage.getItem("resetComision")) {
    if (localStorage.getItem("resetComision") === "true") {
      config.reset = true
    }

    localStorage.removeItem("resetComision")
  }

  const now = new Date()
  const diffInMinutes = (now - dataComissionMasterVer.last) / (1000 * 60)

  if (diffInMinutes >= 5) {
    config.reset = true
  }

  if (config.reset) {
    dataComissionMasterVer = { commission_data: [], date_from: '', date_to: '', cluster: -1, country: -1, office: -1, user: -1 }
  }

  const result = await getComission(dataComissionMasterVer, 1, GetApiCOC('getlistCommissiondataMaster'), user.token, body, config)

  dataComissionMasterVer = { commission_data: result[1].allData, date_from: config.startDate, date_to: config.endDate, cluster: cluster_id, country: country_id, office: office_id, user: user_id }

  //debido a la cantidad de información que se solicita se deficio mejor no usar cache
  //localStorage.setItem("dataComissionMasterVer", JSON.stringify(dataComissionMasterVer))
  localStorage.setItem("dataComissionMasterVer",  JSON.stringify({ commission_data:   [], startDate: '', endDate: '', cluster: -1, country: -1, office: -1, user: -1, last: new Date()}))

  return result
})


// ------------------------------------------------
// GET: Return closure List for Comission
// ------------------------------------------------
let dataComissionMasterUni = JSON.parse(localStorage.getItem("dataComissionMasterUni")) || { commission_data: [], date_from: '', date_to: '', cluster: -1, country: -1, office: -1, user: -1}

mock.onGet('/apps/comissionMasterUni/list').reply(async config => {

  const user = getUserData()
  
  let cluster_id = ''
  let office_id  = ''
  let country_id = ''
  let user_id    = ''

  if (config.manager) {
    if (config.cluster_id !== -1 && config.cluster_id !== '') {
      cluster_id = config.cluster_id
    }

    if (config.country_id !== -1 && config.country_id !== '') {
      country_id = config.country_id
    }

    if (config.office_id !== -1 && config.office_id !== '') {
      office_id = config.office_id
    }
      
    if (config.user_id !== -1 && config.user_id !== '') {
      user_id  = config.user_id
    }
  } else {
    cluster_id = user.usercoc.cluster
    office_id  = user.usercoc.office_id
    country_id = user.usercoc.country
    user_id    = user.usercoc.username
  }
  
  const body = {
    internal_closure_id:    "",
    cluster:                cluster_id,
    country:                country_id,
    office:                 office_id,
    user:                   user_id,
    date_from:              config.startDate,
    date_to:                config.endDate,
    comision_status:        3,
    comision_status2:       4,
    comision_status3:       5
  }

  if (localStorage.getItem("resetComision")) {
    if (localStorage.getItem("resetComision") === "true") {
      config.reset = true
    }

    localStorage.removeItem("resetComision")
  }

  const now = new Date()
  const diffInMinutes = (now - dataComissionMasterUni.last) / (1000 * 60)

  if (diffInMinutes >= 5) {
    config.reset = true
  }

  if (config.reset) {
    dataComissionMasterUni = { commission_data: [], date_from: '', date_to: '', cluster: -1, country: -1, office: -1, user: -1 }
  }

  const result = await getComission(dataComissionMasterUni, 1, GetApiCOC('getlistCommissiondataMaster'), user.token, body, config)

  dataComissionMasterUni = { commission_data: result[1].allData, date_from: config.startDate, date_to: config.endDate, cluster: cluster_id, country: country_id, office: office_id, user: user_id }

  localStorage.setItem("dataComissionMasterUni", JSON.stringify(dataComissionMasterUni))

  return result
})
